import React, { useEffect, useState } from "react";
import { useUser } from "../context/UserContext";
import { useApi } from "../utils/Api";
import { useCurrentPoll } from "../hooks/useCurrentPoll";
import { POLL_VOTED_EVENT, hasVotedHere, markPollVoted, openPoll } from "../utils/poll";

// Banner on the home page: lets people vote after closing the pop-up, or shows that they already have
const PollVoteLink = () => {
  const { user, userLoading } = useUser();
  const { apiFetch } = useApi();
  const { poll } = useCurrentPoll();
  // Re-checked on every render and whenever a vote is recorded, so it follows whichever account is logged in
  const [, setTick] = useState(0);
  const voted = hasVotedHere(poll?.key, user?.id);

  useEffect(() => {
    const onVoted = () => setTick((n) => n + 1);
    window.addEventListener(POLL_VOTED_EVENT, onVoted);
    return () => window.removeEventListener(POLL_VOTED_EVENT, onVoted);
  }, []);

  // Logged in on a device that hasn't seen the poll: they may have voted somewhere else
  useEffect(() => {
    if (userLoading || !user || !poll || voted) return;
    let cancelled = false;
    apiFetch("poll-status", { poll_key: poll.key })
      .then((res) => {
        if (!cancelled && res?.success && res.voted) markPollVoted(poll.key, user.id);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoading, user?.id, poll?.key, voted]);

  if (!poll) return null;

  return (
    <div className="mx-auto mt-10 w-full max-w-[640px] px-4 max-[480px]:mt-8">
      <div className="relative overflow-hidden rounded-xl border border-brand-orange/50 bg-brand-orange/10 px-5 py-4 text-center">
        <div
          aria-hidden="true"
          className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-[#E31B23] via-[#FFC72C] to-[#009B3A]"
        />
        <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-brand-orange">
          Survey{poll.label ? ` - ${poll.label}` : ""}
        </p>
        {voted ? (
          <>
            <p className="mt-1.5 text-[15px] font-semibold text-white">
              <span className="mr-1.5 text-brand-orange">&#10003;</span>
              You've already cast your vote. Thank you!
            </p>
            <p className="mt-1 text-[12px] text-white/60">Look out for our next survey. This is one of a series.</p>
          </>
        ) : (
          <>
            <p className="mt-1.5 text-[15px] font-semibold text-white">{poll.question}</p>
            <button
              type="button"
              onClick={openPoll}
              className="mt-3 cursor-pointer rounded-full border-none bg-brand-orange px-6 py-2 text-sm font-bold text-black transition hover:bg-[#e07010]"
            >
              Vote now
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PollVoteLink;
